import { CopyFilled } from "@ant-design/icons";
import { notification, Space, Tooltip } from "antd";
import { theme } from "../../theme";
import "./DemoWindow.scss";
import { getENV } from "../../stores/consts";
import { ReactComponent as exportIcon } from "../../icons-and-animations/demo-icons/export.svg";
import Icon from "@ant-design/icons";
import PlayerManager from "../../helpers/playerManager";
import { getDemoPlayerUrl } from "../../helpers/demoPlayerUrl";

type Props = {
  project: { id: string };
  scenes?: string[];
  data?: object | null;
};

export function DemoSdkExternalLink({ project, scenes, data }: Props) {
  const version = PlayerManager.get().GetCurrentPlayerVersion();
  const url = getDemoPlayerUrl({
    projectId: project.id,
    env: getENV(),
    scenes,
    data,
    playerVersion: version,
    draftVersion: "latest",
  });

  return (
    <div>
      <Space>
        <Tooltip
          title={"go to DemoPlayer"}
          arrow={{ pointAtCenter: true }}
          color={theme.blings_purple}
        >
          <Icon
            component={exportIcon}
            className="icons"
            style={{ color: "#A9B6C3" }}
            onClick={() => window.open(url)}
          />
        </Tooltip>
        <Tooltip
          title={"Copy to clipboard"}
          arrow={{ pointAtCenter: true }}
          color={theme.blings_purple}
        >
          <CopyFilled
            className="icons"
            style={{ color: "#A9B6C3" }}
            onClick={() => {
              navigator.clipboard.writeText(url);
              notification.open({
                message: "Copied to clipboard",
                duration: 2,
              });
            }}
          />
        </Tooltip>
      </Space>
    </div>
  );
}
